export const LogisticStatusEnum = Object.freeze({
    1: 'In Transit',
    2: 'In Stock',
    3: 'Checked Out',
    4: 'ETA at Destination',
});


